import { Center } from "@mantine/core";
import { useEffect, useRef } from "react";
import { axioTokens } from "../../theme";
import { AxioLoader } from "../AxioLoader";

const SCROLL_ROOT_MARGIN = `${axioTokens.unit[200]}px`;

export function ListScrollSentinel({
  hasMore,
  loadingMore,
  onLoadMore,
}: {
  hasMore?: boolean;
  loadingMore?: boolean;
  onLoadMore?: () => void;
}) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const node = ref.current;
    if (!node || !hasMore || !onLoadMore || typeof IntersectionObserver === "undefined") return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) onLoadMore();
      },
      { root: null, rootMargin: SCROLL_ROOT_MARGIN },
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [hasMore, loadingMore, onLoadMore]);

  if (!hasMore && !loadingMore) return null;

  return (
    <Center ref={ref} py="var(--axio-unit-16)">
      {loadingMore ? <AxioLoader size="sm" /> : null}
    </Center>
  );
}
